import { shallow } from 'zustand/vanilla/shallow';
/**
 * Zustand's `useStoreWithEqualityFn`, but for non-React consumers:
 * https://zustand.docs.pmnd.rs/hooks/use-store-with-equality-fn
 *
 * Use this when one vanilla store or service needs to react to a selected slice of another store
 * without re-running on every state update.
 *
 * @param {(selectedValue: T) => void} onSelectedValueChange - a callback function that is called with the selected value when it changes
 * @param {StoreApi<S>} store - a Zustand store instance
 * @param {(storeState: S) => T} selectorFn - a function that selects a value from the store state
 * @param {<T>(valueA: T, valueB: T) => boolean} equalityFn - an optional function that checks if two values are equal
 * @
 */
export const subscribeWithEqualityFn = (onSelectedValueChange, store, selectorFn, equalityFn = shallow) => {
    let previousSelectedValue = selectorFn(store.getState());
    onSelectedValueChange(previousSelectedValue);
    const unsubscribe = store.subscribe(state => {
        const selectedValue = selectorFn(state);
        if (equalityFn(selectedValue, previousSelectedValue)) {
            return;
        }
        previousSelectedValue = selectedValue;
        onSelectedValueChange(selectedValue);
    });
    return unsubscribe;
};
//# sourceMappingURL=subscribeWithEqualityFn.js.map